import React from "react";
import { CBadge } from "@coreui/react";
import { useTranslationContext } from "@/context/TranslationContext";
import { contentModeration } from "@/constants/translation/contentModeration.translation";

/**
 * Active / Deactivated badge of a moderated item.
 * @param {Object} props
 * @param {string} props.status - "active" | "deactivated" (moderationStatus from the API)
 */
const ModerationStatusBadge = ({ status }) => {
  const t = useTranslationContext();
  const isDeactivated = status === "deactivated";

  return (
    <CBadge color={isDeactivated ? "danger" : "success"}>
      {t(
        isDeactivated
          ? contentModeration.status.deactivated
          : contentModeration.status.active,
      )}
    </CBadge>
  );
};

export default ModerationStatusBadge;
